const LOGIN_MODULE_PROVIDERS = [];

export {LOGIN_MODULE_PROVIDERS};
